import { ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class BankAccountType extends ModelBase {
    static typeName = "BankAccountType";

    public bankAccountTypeId: number = 0;

    @Rules.StringLength(30)
    @Rules.Required()
    public bankAccountTypeName: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.bankAccountTypeName) {
            return "New bank account type";
        } else {
            return this.bankAccountTypeName;
        }
    }
}